export default __webpack_public_path__ + "c0475d0.png";